/* Barra superior con cuenta atras.

   Dos modos:
   - 'daily': cuenta lo que queda del dia en la zona horaria
     elegida (por defecto Europe/Madrid) y se reinicia solo al
     pasar la medianoche. Va de 23:59:59 a 00:00:00.
   - 'date': cuenta hasta una fecha concreta y, cuando pasa,
     la barra se apaga en vez de quedarse a cero.

   La barra arranca oculta y solo se enciende cuando hay un
   tiempo real que mostrar. */
if (!customElements.get('countdown-bar')) {
  customElements.define(
    'countdown-bar',
    class CountdownBar extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.cbar');
        this.clock = this.querySelector('[data-cbar-clock]');
        if (!this.bar || !this.clock) return;

        this.mode = this.dataset.mode === 'date' ? 'date' : 'daily';
        this.timezone = this.dataset.timezone || 'Europe/Madrid';

        if (this.mode === 'date') {
          this.deadline = new Date(this.dataset.deadline).getTime();
          if (isNaN(this.deadline)) return;
        }

        this.tick();
        this.timer = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.timer) window.clearInterval(this.timer);
      }

      /* Segundos transcurridos hoy en la zona horaria elegida.
         Si el navegador no conoce la zona, cae en la hora local. */
      secondsIntoDay() {
        try {
          const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: this.timezone,
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }).formatToParts(new Date());

          const value = (type) => parseInt(parts.find((p) => p.type === type).value, 10);

          return (value('hour') % 24) * 3600 + value('minute') * 60 + value('second');
        } catch (error) {
          const now = new Date();
          return now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
        }
      }

      remaining() {
        if (this.mode === 'daily') return 86400 - this.secondsIntoDay();
        return Math.floor((this.deadline - Date.now()) / 1000);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
        this.bar.classList.remove('is-live');
      }

      tick() {
        let left = this.remaining();

        if (left <= 0) {
          if (this.mode === 'date') return this.stop();
          left = 86400;
        }

        const pad = (n) => String(n).padStart(2, '0');
        const hours = Math.floor(left / 3600);
        const minutes = Math.floor((left % 3600) / 60);
        const seconds = left % 60;

        this.clock.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
        this.clock.setAttribute('datetime', 'PT' + hours + 'H' + minutes + 'M' + seconds + 'S');
        this.bar.classList.add('is-live');
      }
    }
  );
}
